<template>
  <section class="section section-yellow section-products">
        <div class="container">
            <h2 class="mb-1">
                {{ $t('samples.title') }}
            </h2>

            <a
              v-for="category in rowsCategories"
              :key="category.id"
              href="#"
              class="badge badge-pill badge-light text-dark text-decoration-none mt-4"
              :class="{
                  selected: (category.id === selectedCategory.id),
              }"
              @click.stop.prevent="selectCategory(category)"
            >
              {{ $t(`categories.${category.slug}`) }}
            </a>

            <div class="row mt-5">
              <lesson-item
                v-for="lesson in lessons"
                :key="lesson.id"
                :lesson="lesson"
              />
            </div>
          </div>
    </section>
</template>

<script>
import axios from "axios";
import SeriesItem from "./SeriesItem.vue";
import LessonItem from "./LessonItem.vue";

export default {
  name: "SamplesList",

  components: {
    SeriesItem,
    LessonItem,
  },

  data() {
    return {
      rowsCategories: [],
      lessons: [],
      selectedCategory: {},
    };
  },

  watch: {
    selectedCategory() {
      axios({
        method: "get",
        url: `/api/categories/${this.selectedCategory.id}/sample-lessons`,
      })
        .then((response) => {
          this.lessons = response.data;
        });
    },
  },

  mounted() {
    this.getCategories();
  },

  methods: {
    getCategories() {
      axios({
        method: "get",
        url: "/api/categories",
      })
        .then((response) => {
          this.rowsCategories = response.data;
          this.selectedCategory = this.rowsCategories[0];
        });
    },

    selectCategory(category) {
      this.selectedCategory = category;
    },
  },
};
</script>
